import React, { useEffect, useMemo, useState } from "react";
import "./Footer.css";
import bsmLogo from "../../assets/bsm_mobile_logo.png";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import CropSquareRoundedIcon from "@mui/icons-material/CropSquareRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLocation } from "react-router-dom";
import XIcon from '@mui/icons-material/X';

const Footer = () => {
  const location=useLocation()
  const searchParams = new URLSearchParams(location.search);
  const lar = searchParams.get("lar") || "undefined";
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("language");
    return saved === "Spanish" ? "Spanish" : "English";
  });

  useEffect(() => {
    const handleLangChanged = (e) => {
      const next = e?.detail;
      setLang(next === "Spanish" ? "Spanish" : "English");
    };

    window.addEventListener("langChanged", handleLangChanged);
    return () => window.removeEventListener("langChanged", handleLangChanged);
  }, []);

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "language") {
        setLang(e.newValue === "Spanish" ? "Spanish" : "English");
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const t = useMemo(() => {
    const translations = {
      English: {
        home: "Home",
        about: "About",
        resourcesAndTools: "Resource And Tools",
        mortgageTypes: "Mortgage Types",
        reviews: "Reviews",
        blogs: "Blogs",
        exploreLoanOptions: "Explore Loan Options",
        buyAHome: "Buy-A-Home",
        loanPortal: "Loan Portal",
        learningCenter: "Learning Center",
        faqs: "FAQ's",
        calculator: "Calculator",
        refinance: "Refinance",
        requestVaLoan: "Request VA Loan",
        requestFhaLoan: "Request FHA Loan",
        rehabLoanForm: "Rehab Loan Form",
        getInstantQuote: "Get Instant Quote",
        applyNow: "Apply Now",
        findUs: "FIND US",
        privacyPolicy: "Privacy Policy",
        licensingInfo: "Licensing Info",
        companyName: "BOND STREET MORTGAGE LLC",
        tagline: "OUR WORD IS OUR BOND",
      },
      Spanish: {
        home: "Inicio",
        about: "Acerca de",
        resourcesAndTools: "Recursos y herramientas",
        mortgageTypes: "Tipos de hipoteca",
        reviews: "Reseñas",
        blogs: "Blogs",
        exploreLoanOptions: "Explorar opciones de préstamo",
        buyAHome: "Comprar una casa",
        loanPortal: "Portal de préstamos",
        learningCenter: "Centro de aprendizaje",
        faqs: "Preguntas frecuentes",
        calculator: "Calculadora",
        refinance: "Refinanciar",
        requestVaLoan: "Solicitar préstamo VA",
        requestFhaLoan: "Solicitar préstamo FHA",
        rehabLoanForm: "Formulario de préstamo de rehabilitación",
        getInstantQuote: "Obtener cotización instantánea",
        applyNow: "Solicitar ahora",
        findUs: "ENCUÉNTRANOS",
        privacyPolicy: "Política de privacidad",
        licensingInfo: "Información de licencias",
        companyName: "BOND STREET MORTGAGE LLC",
        tagline: "NUESTRA PALABRA ES NUESTRO COMPROMISO",
      },
    };

    return translations[lang] || translations.English;
  }, [lang]);

  return (
    <footer className="main1">
      <div className="c-prefooter">
        <div className="container1">
          <div className="c-last">
            <ul className="c-socials">
              <li>
                <img src={bsmLogo} alt="bsm logo" className="footer-logo" />
              </li>
              <li>
                <h3 className="font-uppercase">{t.companyName}</h3>
                <p className="c-text">{t.tagline}</p>
              </li>
            </ul>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="c-container c-first">
                <ul className="c-links">
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/#home"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.home}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/#about"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.about}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/components/resources-and-tools.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.resourcesAndTools}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/components/mortgage-types.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.mortgageTypes}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/#reviews"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.reviews}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/blog/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.blogs}</p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3">
              <div className="c-container c-first">
                <ul className="c-links">
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/short-app/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.exploreLoanOptions}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/components/forms/buy-a-home.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.buyAHome}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetmortgageq.com/?borrowerportal&siteid=2191488867"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.loanPortal}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/components/resources-and-tools.html#learning-center"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.learningCenter}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/components/resources-and-tools.html#FAQs"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.faqs}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/components/resources-and-tools.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.calculator}</p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-3">
              <div className="c-container c-first">
                <ul className="c-links">
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/components/forms/refinance.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.refinance}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://bondstreetmortgage.com/valoanrequest/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.requestVaLoan}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/components/forms/buy-a-home.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.requestFhaLoan}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.bondstreetloans.com/components/forms/rehab.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.rehabLoanForm}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://bondstreetmortgage.com/instantquotetool/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link">{t.getInstantQuote}</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://www.bondstreetmortgageq.com/?loanapp&siteid=2191488867&lar=${lar}&workFlowId=72056`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="font-link"> {t.applyNow} </p>
                    </a>
                  </li>
                </ul>

              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="c-first">
                    <ul className="c-img">
                      <li>
                        <img
                          src={require("../../assets/el.png")}
                          alt="EL Logo"
                          width="60px"
                          height="60px"
                        />
                      </li>
                      <li>
                        <img
                          src={require("../../assets/bbb.png")}
                          alt="BBB Logo"
                          width="60px"
                          height="60px"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="c-container c-last">

                <ul className="c-address">
                  <div className="c-content-title-1">
                    <h3 className="c-font-uppercase c-font-bold c-font-white">
                      {t.findUs}
                    </h3>
                    <div className="c-line-left hide"></div>
                    <ul className="c-socials">
                      <li style={{ padding: "0px", width: "50px" }}>
                        <a
                          href="https://facebook.com/BondStreetMortgage/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={require("../../assets/facebook.png")}
                            alt="Facebook"
                            width="70%"
                          />
                        </a>
                      </li>
                      <li style={{ padding: "0px", width: "50px" }}>
                        <a href="https://twitter.com/BondStreetMtg" target="_blank" rel="noreferrer" >
                          <XIcon style={{ color: "black", width: "50%", height: "auto" }} />
                        </a>
                      </li>
                      <li style={{ padding: "0px", width: "50px" }}>
                        <a
                          href="https://www.youtube.com/user/BondStreetMortgage"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={require("../../assets/you-tube.png")}
                            alt="YouTube"
                            width="70%"
                          />
                        </a>
                      </li>
                      <li style={{ padding: "0px", width: "50px" }}>
                        <a
                          href="https://instagram.com/bondstreetmortgage?igshid=3nlq9r6l4zo2"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={require("../../assets/instagram.png")}
                            alt="Instagram"
                            width="70%"
                          />
                        </a>
                      </li>
                      <li style={{ padding: "0px", width: "50px" }}>
                        <a
                          href="https://www.linkedin.com/company/bond-street-mortgage-llc"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={require("../../assets/linkedin.png")}
                            alt="LinkedIn"
                            width="70%"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <li className="font-link">
                    <a
                      href="http://maps.google.com/maps?q=115+W Century+Road+Suite 115,+Paramus,+NJ+07652"
                      target="_blank"
                      rel="noreferrer"
                      className="font-link"
                    >
                      <LocationOnOutlinedIcon
                        className="c-theme-font"
                        fontSize="small"
                      />
                      115 West Century Road Suite 115, Paramus, NJ 07652
                    </a>
                  </li>
                  <li className="font-link">
                    <a
                      href="tel:+18885885522"
                      rel="noreferrer"
                      draggable="false"
                      className="font-link"
                    >
                      <LocalPhoneRoundedIcon
                        className="c-theme-font"
                        fontSize="small"
                      />
                      <c2d_cc_5d8617261cdf485da5df67e34f5f63ef
                        data-num="(888) 588-5522"
                        id="c2d_1"
                      >
                        (888) 588-5522
                      </c2d_cc_5d8617261cdf485da5df67e34f5f63ef>
                    </a>
                  </li>
                  <li className="font-link">
                    <MailOutlineRoundedIcon
                      className="c-theme-font"
                      fontSize="small"
                    />
                    <a
                      className="font-link"
                      href="mailto:loaninfo@bondstreetloans.com"
                      rel="noreferrer"
                    >
                      loaninfo@bondstreetloans.com
                    </a>
                  </li>
                  <li className="font-link">
                    <CropSquareRoundedIcon
                      className="c-theme-font"
                      fontSize="small"
                    />
                    <a
                      className="font-link"
                      href="https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/COMPANY/191351"
                      target="_blank"
                      rel="noreferrer"
                    >
                      NMLS # 191351
                    </a>
                  </li>
                  <li className="font-link">
                    <PublicRoundedIcon
                      className="c-theme-font"
                      fontSize="small"
                    />
                    <a
                      className="font-link"
                      href="https://www.bondstreetloans.com/components/Privacy.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t.privacyPolicy}
                    </a>
                  </li>
                  <li className="font-link">
                    <InfoOutlinedIcon
                      className="c-theme-font"
                      fontSize="small"
                    />
                    <a
                      className="font-link"
                      href="https://www.bondstreetloans.com/components/License.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t.licensingInfo}
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>

        <div></div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;